export enum Colour {
    darkBlue = '#111517',
    darkBlueAlt = '#192024',
    primaryBlue = '#1ea7fd',
    purpleBlue = '#867ae9',
    elementsBackground = '#2b3945',
    primaryText = '#111517',
    white = '#ffffff',
    dodgerBlue = '#0483ff',
    gray = '#6E7C7C',
    lightGray = '#e6e3e3',
    danger = '#fd8a8a',
    whiteModalBackground = 'rgba(225, 225, 225, 0.4)',
    whiteSmoke = '#f1f4fa',
    whiteSmokeAlt = '#ffffef',
    warning = '#ff6701',
    warningLight = '#fa802e',
    warningShade = '#fcecdd',
    successShade = '#e8ffff',
    success = '#41aea9',
}
